import PropTypes from 'prop-types';
import ExternalHyperlink from '../ExternalHyperlink/ExternalHyperlink';

/*
#tailwind
*/

const protocols = new Set(['http:', 'https:']);

const isUrl = (s) => {
  try {
    const url = new URL(s);
    return protocols.has(url.protocol);
  } catch (e) {
    return false;
  }
};

const zipWithSpaces = (array, next) => (array.length ? array.concat(' ', next) : [next]);

const ParsedString = ({ string, allowHyperlinks, hyperlinkProps, ...other }) => {
  if (!allowHyperlinks) return <span {...other}>{string}</span>;

  return string
    .split(' ')
    .map((s, i) =>
      isUrl(s) ? (
        // eslint-disable-next-line react/no-array-index-key
        <ExternalHyperlink key={i} url={s} {...hyperlinkProps} {...other}>
          {s}
        </ExternalHyperlink>
      ) : (
        s
      )
    )
    .reduce(zipWithSpaces, []);
};

ParsedString.propTypes = {
  string: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  hyperlinkProps: PropTypes.object,
  allowHyperlinks: PropTypes.bool,
};

ParsedString.defaultProps = {
  hyperlinkProps: undefined,
  allowHyperlinks: true,
};

export default ParsedString;
